export const validateEmailFormat = (value: string) =>
  /^[A-Z0-9._%+'-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(value);
